import Box from 'components/shared/Box'
import styled from 'styled-components'
import { fadeInOnRender } from 'styles/animations'
import { respondAbove } from 'styles/mediaQueries'

export const CityBreakTicketContainer = styled(Box)`
    display: grid;
    grid-template-areas:
        'person price'
        'details price';
    grid-template-columns: 1fr auto;
    gap: 8px;
    align-items: center;
    width: 100%;
    padding: 16px;
    border: 2px solid ${({ theme }) => theme.colors.grayscale_300};
    border-radius: 8px;
    ${fadeInOnRender}

    @media ${respondAbove.xl} {
        padding: 24px 32px;
        gap: 16px;
        grid-template-areas: 'person details price';
        grid-template-columns: 1.5fr 1.5fr 1fr;
    }

    .person {
        grid-area: person;
    }
    .details {
        grid-area: details;
        justify-self: flex-start;

        @media ${respondAbove.xl} {
            justify-self: center;
        }
    }
    .price {
        grid-area: price;
        justify-self: end;
    }
`
